<section class="logo-area2 bar2" style="    position: fixed;
    width: 100%;
    background: white;
    z-index: 1;
    margin-top: -3px;">
  <div class="container">
    <div class="row flex-column-reverse flex-md-row align-items-center">
      <div class="col-md-6 col-12">
        <div class="menu">

          <ul class="list-inline">

            <li class="list-inline-item">

             <a routerLink="tienda-online-cuba/">
                <i class="fa fa-th-large"></i>
                Categorías
              </a>

            </li>

            <li class="list-inline-item">

              <a class="pl-3" routerLink="tiendas-asociadas/">
                <i class="fa fa-shopping-cart"></i>
                Tiendas
              </a>


            </li>

            <li class="list-inline-item">

              <a class="pl-3" routerLink="vender-mercado-online-cuba">
                <i class="fa fa-shopping-basket"></i>
                <div class="d-flex d-lg-none">Vender</div>
                <div class="d-none d-lg-flex">Vender en Cubatel</div>
              </a>
            </li>

          </ul>
        </div>
      </div>
      <div class="col-md-6 col-12">
        <app-search></app-search>
       <!--  <form action="#" class="search-bar d-flex">
          <input [formControl]="searhControl" type="text" name="search-bar" placeholder="Buscar...">
          <div class="search-cat">
            <div class="btn-group" style="margin-top: 4px;">
              <a style="color: #007bff;font-size: 15px;" class="btn dropdown-toggle" data-toggle="dropdown" href="#">
                <img width="80px" src="assets/js/xemart/msdropdown/cubatel.png"/>
                <span class="caret"></span>
              </a>
              <ul class="dropdown-menu" style="border:none; box-shadow: rgba(17, 12, 46, 0.15) 0px 48px 100px 0px;" >
                  <li style="margin-left: 15px !important;">
                    <a href="javascript:void(0)">
                      <img width="80px" src="assets/js/xemart/msdropdown/cubatel.png"/>
                    </a>
                   </li>
                   <li style="border: 1px solid #eee;margin: 5px 15px 5px 15px;"></li>
                  <li style="margin-left: 15px !important;">
                    <a href="javascript:void(0)">
                      <img width="80px" src="assets/js/xemart/msdropdown/amazon.png"/>
                    </a>
                   </li>
              </ul>
            </div>
        </div>


          <button class="btnSearch" type="button" (click)="search()">
            <i class="fa fa-search"></i>
          </button>
        </form> -->
      </div>

    </div>
  </div>
</section>


<section class="menu-area2 bar3">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-md-12 d-flex align-items-center pr-0">
        <div class="main-menu" style="cursor: pointer;">
          <ul class="list-unstyled list-inline d-flex justify-content-between justify-content-md-start">
            <li class="list-inline-item mega-menu" id="mega-menu">
              <span class="link-separator">
                <i class="fa fa-map-marker"></i>
                <span class="select-location" *ngIf="!province">Elegir ubicación</span>
                <span class="location-text" *ngIf="province && locationType == LocationType.Municipality"><small *ngIf="municipality">{{municipality}}, <strong>{{province}}</strong></small></span>
                <span class="location-text" *ngIf="province && locationType == LocationType.Province"><small>{{province}}</small></span>
              </span>
              <div class="mega-box w-100">
                <div class="row">
                  <div *ngFor="let location of locations" class="col-6 col-md-3">
                    <div class="sm-phn">
                      <span style="font-weight: bold !important;" class="h6-province cursor-pointer mb-0 p-2" (click)="action(location.value, LocationType.Province)">{{location.text}}</span>
                      <div *ngFor="let municipality of location.children" class="dept-box cursor-pointer">
                        <span class="p-2" (click)="action(municipality.value)">{{municipality.text}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <li class="list-inline-item d-none d-md-flex align-items-center">
              <a (click)="productRouter()">Productos</a>
            </li>
            <li *ngIf="turnOnAmazon" class="list-inline-item d-none d-md-flex align-items-center">
              <a class="position-relative" routerLink="envios/amazon-para-cuba">Amazon</a>
            </li>
            <li *ngIf="turnOnShein" class="list-inline-item d-none d-md-flex align-items-center">
              <a class="position-relative" routerLink="envios/shein-para-cuba">Shein</a>
            </li>
            <li *ngIf="turnOnWalmart" class="list-inline-item d-none d-md-flex align-items-center">
              <a class="position-relative" routerLink="envios/walmart-para-cuba">Walmart<p style="top: 5%;right: -20px" class="bg-danger rounded-pill text-white px-1 mb-0 position-absolute d-flex"><small>Nuevo</small></p></a>
            </li>
            <li *ngIf="turnOnHomeDepot" class="list-inline-item d-none d-lg-flex align-items-center">
              <a class="position-relative" routerLink="envios/home-depot-para-cuba">Home Depot<p style="top: 5%;right: -20px" class="bg-danger rounded-pill text-white px-1 mb-0 position-absolute d-flex"><small>Nuevo</small></p></a>
            </li>
            <li *ngIf="turnOnBestBuy" class="list-inline-item d-none d-lg-flex align-items-center">
              <a class="position-relative" routerLink="envios/best-buy-para-cuba">Best Buy<p style="top: 5%;right: -20px" class="bg-danger rounded-pill text-white px-1 mb-0 position-absolute d-flex"><small>Nuevo</small></p></a>
            </li>

            <!-- <li class="list-inline-item d-none d-md-flex align-items-center">
              <a routerLink="tienda-online-cuba/ofertas-descuentos-tienda-envios-cuba">Ofertas</a>
            </li>
            <li class="list-inline-item d-none d-md-flex align-items-center">
              <a routerLink="tienda-online-cuba/productos-envio-cuba">Envíos</a>
            </li>
             <li class="list-inline-item d-none d-lg-flex align-items-center">
              <a routerLink="tienda-online-cuba/comida">Alimentos</a>
            </li>
            <li class="list-inline-item d-none d-xl-flex align-items-center">
              <a routerLink="tienda-online-cuba/bebida">Bebidas</a>
            </li>
            <li class="list-inline-item d-none d-xl-flex align-items-center">
              <a routerLink="tienda-online-cuba/combos">Combos</a>
            </li>
            <li class="list-inline-item d-none d-xl-flex align-items-center">
              <a routerLink="tienda-online-cuba/celulares-computadoras">Tecnología</a>
            </li>
            <li class="list-inline-item d-none d-xl-flex align-items-center">
              <a routerLink="tienda-online-cuba/electrodomesticos-hogar" >Hogar</a>
            </li> -->

           <li class="list-inline-item d-none d-lg-flex align-items-center">
              <a
                (click)="handleClick($event)"
                data-href="market/tienda-online-cuba/ofertas-descuentos-tienda-envios-cuba"
                routerLink="tienda-online-cuba/ofertas-descuentos-tienda-envios-cuba">
                Ofertas
              </a>
            </li>

            <li
              class="list-inline-item d-none d-xl-flex align-items-center">
              <a
                (click)="handleClick($event)"
                data-href="market/tienda-online-cuba/productos-envio-cuba"
                routerLink="tienda-online-cuba/productos-envio-cuba">
                Envíos
              </a>
            </li>

             <!--<li class="list-inline-item d-none d-xl-flex align-items-center">
              <a
                (click)="handleClick($event)"
                data-href="market/tienda-online-cuba/comida"
                routerLink="tienda-online-cuba/comida">
                Alimentos
              </a>
            </li>-->

            <!--<li class="list-inline-item d-none d-xl-flex align-items-center">
              <a
                (click)="handleClick($event)"
                data-href="market/tienda-online-cuba/bebida"
                routerLink="tienda-online-cuba/bebida">Bebidas</a>
            </li>-->

            <!--<li class="list-inline-item d-none d-xl-flex align-items-center">
              <a
                (click)="handleClick($event)"
                data-href="market/tienda-online-cuba/combos"
                routerLink="tienda-online-cuba/combos">
                Combos
              </a>
            </li>-->

            <!--<li class="list-inline-item d-none d-xl-flex align-items-center">
              <a
                (click)="handleClick($event)"
                data-href="market/tienda-online-cuba/celulares-computadoras"
                routerLink="tienda-online-cuba/celulares-computadoras">
                Tecnología
              </a>
            </li>-->

            <!--<li class="list-inline-item d-none d-xl-flex align-items-center">
              <a
               (click)="handleClick($event)"
               data-href="market/tienda-online-cuba/electrodomesticos-hogar"
               routerLink="tienda-online-cuba/electrodomesticos-hogar">
               Hogar
              </a>
            </li>-->

            <li  *isAuthenticated class="list-inline-item d-flex align-items-center mr-0">
              <div class="main-menu pt-0 d-block d-md-none">
                <div class="top-left d-flex align-items-center">
                  <ul class="list-unstyled list-inline d-flex justify-content-between">
                    <li *ngIf="(shoppingCart$ | async)?.data.totalItems > 0 && isCheckoutPage" class="list-inline-item cup-btn mt-0"><a routerLink="revisar-completar-pedido">Pagar</a></li>
                  </ul>
                </div>
              </div>
            </li>
            <li class="list-inline-item d-flex align-items-center link-separator mr-0 pr-0 d-flex">
              <section class="menu-area2">
                <div class="container">
                  <div class="row">
                    <div >
                      <div class="sidemenu">
                        <p><i class="fa fa-list-ul"></i></p>
                        <ul class="list-unstyled gt-menu" style="width: 200px">
                          <li class="d-md-none w-100">
                            <a (click)="collapseMenu()" routerLink="productos-compras-cuba-online">Productos</a>
                          </li>
                          <li *ngIf="turnOnAmazon" class="d-md-none w-100">
                            <a (click)="collapseMenu()" routerLink="envios/amazon-para-cuba">Amazon</a>
                          </li>
                          <li *ngIf="turnOnShein" class="d-md-none w-100">
                            <a (click)="collapseMenu()" routerLink="envios/shein-para-cuba">Shein</a>
                          </li>
                          <li *ngIf="turnOnWalmart" class="d-md-none w-100">
                            <a (click)="collapseMenu()" routerLink="envios/walmart-para-cuba">Walmart<p style="top: 0;right: 40%; text-transform: unset; padding: 0px 22px; height: 21px" class="bg-danger rounded-pill px-1 mb-0 position-absolute d-flex"><small >Nuevo</small></p></a>
                          </li>
                          <li *ngIf="turnOnHomeDepot" class="d-lg-none w-100">
                            <a (click)="collapseMenu()" routerLink="envios/home-depot-para-cuba">Home Depot<p style="top: 0;right: 25%; text-transform: unset; padding: 0px 22px; height: 21px" class="bg-danger rounded-pill px-1 mb-0 position-absolute d-flex"><small >Nuevo</small></p></a>
                          </li>
                          <li *ngIf="turnOnBestBuy" class="d-lg-none w-100">
                            <a (click)="collapseMenu()" routerLink="envios/best-buy-para-cuba">Best Buy<p style="top: 0;right: 25%; text-transform: unset; padding: 0px 22px; height: 21px" class="bg-danger rounded-pill px-1 mb-0 position-absolute d-flex"><small >Nuevo</small></p></a>
                          </li>
                          <li class="d-lg-none w-100">
                            <a (click)="collapseMenu()" routerLink="tienda-online-cuba/ofertas-descuentos-tienda-envios-cuba">Ofertas</a>
                          </li>
                          <li class="d-xl-none w-100">
                            <a (click)="collapseMenu()" routerLink="tienda-online-cuba/productos-envio-cuba">Envíos</a>
                          </li>
                          <li class="w-100">
                            <a (click)="collapseMenu()" routerLink="tienda-online-cuba/comida">Alimentos</a>
                          </li>
                          <li class="w-100">
                            <a (click)="collapseMenu()" routerLink="tienda-online-cuba/bebida">Bebidas</a>
                          </li>
                          <li class="w-100">
                            <a (click)="collapseMenu()" routerLink="tienda-online-cuba/combos">Combos</a>
                          </li>
                          <li class="w-100">
                            <a (click)="collapseMenu()" routerLink="tienda-online-cuba/celulares-computadoras" >Tecnologías</a>
                          </li>
                          <li class="w-100">
                            <a (click)="collapseMenu()" routerLink="tienda-online-cuba/electrodomesticos-hogar">Hogar</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </li>
          </ul>
        </div>
        <div *isAuthenticated class="main-menu pt-0 d-none d-md-flex pl-4 ml-xl-auto pr-xl-5">
          <div class="top-left d-flex align-items-center">
            <ul class="list-unstyled list-inline d-flex justify-content-between justify-content-md-start">
              <li class="list-inline-item">
                <a routerLink="pedidos">Mis pedidos</a>
              </li>
              <li *ngIf="(shoppingCart$ | async)?.data.totalItems > 0 && isCheckoutPage" class="list-inline-item cup-btn">
                <a routerLink="revisar-completar-pedido">
                  Pagar
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>

